import React from "react";
import { useState, useEffect, useCallback } from "react";
import Swal from "sweetalert2";
import { FormControl, FormLabel, Modal } from "react-bootstrap";
import axios from "../../../../utils/axios";

const EditDeviceDealer = (props) => {
  const [deviceDetail, setDeviceDetail] = useState([]);
  const [name, setName] = useState("");
  const [deviceIMEI, setDeviceIMEI] = useState("");
  const [flowrateUnit, setFlowrateUnit] = useState("");
  const [totalizerUnit, setTotalizerUnit] = useState("");
  const [levelDepthUnit, setLevelDepthUnit] = useState("");
  const [depth, setDepth] = useState(0);
  const [simNumber, setSimNumber] = useState("");
  const [latitude, setLatitude] = useState("");
  const [longitude, setLongitude] = useState("");
  const [location, setLocation] = useState("");
  const [installationDate, setInstallationDate] = useState("");
  const [activationDate, setActivationDate] = useState("");
  const [subscriptionEndDate, setSubscriptionEndDate] = useState("");
  const [subscriptionCost, setSubscriptionCost] = useState("");

  const getDetail = useCallback(async () => {
    try {
      const viewDeviceDetail = await axios.post("view/device/details", {
        deviceId: props.id,
      });

      const data = viewDeviceDetail?.data[0];
      setDeviceDetail(data);
      setName(data?.alias_name);
      setDeviceIMEI(data?.imei);
      setFlowrateUnit(data?.flow_unit || "");
      setTotalizerUnit(data?.total_unit || "");
      setLevelDepthUnit(data?.level_unit || "");
      setDepth(data?.depth || 0);
      setSimNumber(data?.sim_number || "");
      setLatitude(data?.latitude || "");
      setLongitude(data?.longitude || "");
      setLocation(data?.location || "");

      // Convert UTC dates to local timezone before formatting
      if (data?.installation_date) {
        const date = new Date(data.installation_date);
        const localDate = new Date(
          date.getTime() - date.getTimezoneOffset() * 60000
        );
        setInstallationDate(localDate.toISOString().split("T")[0]);
      }
      if (data?.activation_date) {
        const date = new Date(data.activation_date);
        const localDate = new Date(
          date.getTime() - date.getTimezoneOffset() * 60000
        );
        setActivationDate(localDate.toISOString().split("T")[0]);
      }
      if (data?.subscription_end) {
        const date = new Date(data.subscription_end);
        const localDate = new Date(
          date.getTime() - date.getTimezoneOffset() * 60000
        );
        setSubscriptionEndDate(localDate.toISOString().split("T")[0]);
      }
      setSubscriptionCost(data?.subscription_cost || "");
    } catch (error) {}
  }, [props.id]);

  useEffect(() => {
    if (props?.id) {
      getDetail();
    }
  }, [props.id, getDetail]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await axios.post("dealer/change/device/details", {
        deviceId: deviceDetail.id,
        alias_name: name,
        depth: depth === "" ? null : depth,
        sim_number: simNumber,
        latitude: latitude === "" ? null : latitude,
        longitude: longitude === "" ? null : longitude,
        location: location,
        flow_unit: flowrateUnit,
        total_unit: totalizerUnit,
        level_unit: levelDepthUnit,
      });

      props.onHide();

      Swal.fire({
        title: "Success",
        text: "Details are successfully updated",
        icon: "success",
      });
    } catch (error) {
      Swal.fire({
        title: "Try Again",
        text: "Try again",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  const handleReset = () => {
    setName(deviceDetail.alias_name);
    setFlowrateUnit(deviceDetail.flow_unit);
    setTotalizerUnit(deviceDetail.total_unit);
    setLevelDepthUnit(deviceDetail.level_unit);
    setDepth(deviceDetail.depth);
    setSimNumber(deviceDetail.sim_number);
    setLatitude(deviceDetail.latitude);
    setLongitude(deviceDetail.longitude);
    setLocation(deviceDetail.location);
  };

  return (
    <Modal
      {...props}
      dialogClassName="modal-75w"
      aria-labelledby="example-custom-modal-styling-title"
    >
      <button className="close-icon" onClick={props.onHide}>
        <svg
          width="31"
          height="31"
          viewBox="0 0 31 31"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M18.4039 15.7032L30.3126 3.81334C30.6685 3.4574 30.8685 2.97463 30.8685 2.47125C30.8685 1.96787 30.6685 1.4851 30.3126 1.12916C29.9567 0.77321 29.4739 0.573242 28.9705 0.573242C28.4671 0.573242 27.9844 0.77321 27.6284 1.12916L15.7386 13.0379L3.84879 1.12916C3.49285 0.77321 3.01008 0.573243 2.5067 0.573243C2.00332 0.573243 1.52055 0.77321 1.16461 1.12916C0.808663 1.4851 0.608695 1.96787 0.608695 2.47125C0.608695 2.97463 0.808663 3.4574 1.16461 3.81334L13.0733 15.7032L1.16461 27.593C0.987436 27.7687 0.846811 27.9778 0.750844 28.2081C0.654878 28.4385 0.605469 28.6855 0.605469 28.9351C0.605469 29.1846 0.654878 29.4317 0.750844 29.662C0.846811 29.8924 0.987436 30.1014 1.16461 30.2772C1.34033 30.4543 1.5494 30.595 1.77975 30.6909C2.01009 30.7869 2.25716 30.8363 2.5067 30.8363C2.75624 30.8363 3.00331 30.7869 3.23366 30.6909C3.464 30.595 3.67307 30.4543 3.84879 30.2772L15.7386 18.3684L27.6284 30.2772C27.8041 30.4543 28.0132 30.595 28.2435 30.6909C28.4739 30.7869 28.721 30.8363 28.9705 30.8363C29.22 30.8363 29.4671 30.7869 29.6975 30.6909C29.9278 30.595 30.1369 30.4543 30.3126 30.2772C30.4898 30.1014 30.6304 29.8924 30.7264 29.662C30.8223 29.4317 30.8717 29.1846 30.8717 28.9351C30.8717 28.6855 30.8223 28.4385 30.7264 28.2081C30.6304 27.9778 30.4898 27.7687 30.3126 27.593L18.4039 15.7032Z"
            fill="black"
          />
        </svg>
      </button>
      <Modal.Body>
        <h4 className="modal-title">Edit Device</h4>
        <form action="" className="modal-form">
          <div className="form-fields">
            <div>
              <FormLabel>Device Name</FormLabel>
              <FormControl
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Enter Device Name....."
              />
            </div>

            {/* READ-ONLY: IMEI Number */}
            <div>
              <FormLabel>IMEI Number</FormLabel>
              <FormControl
                value={deviceIMEI}
                placeholder="IMEI Number"
                disabled
                readOnly
                style={{ backgroundColor: "#f0f0f0", cursor: "not-allowed" }}
              />
            </div>

            <div>
              <FormLabel>Flowrate Unit</FormLabel>
              <FormControl
                type="text"
                value={flowrateUnit}
                onChange={(e) => setFlowrateUnit(e.target.value)}
                placeholder="e.g., m³/hr"
              />
            </div>

            <div>
              <FormLabel>Totalizer Unit</FormLabel>
              <FormControl
                type="text"
                value={totalizerUnit}
                onChange={(e) => setTotalizerUnit(e.target.value)}
                placeholder="e.g., m³"
              />
            </div>

            <div>
              <FormLabel>Level Depth Unit</FormLabel>
              <FormControl
                type="text"
                value={levelDepthUnit}
                onChange={(e) => setLevelDepthUnit(e.target.value)}
                placeholder="e.g., meters"
              />
            </div>

            <div>
              <FormLabel>Depth of device</FormLabel>
              <FormControl
                type="number"
                value={depth}
                onChange={(e) => setDepth(e.target.value)}
                placeholder="Enter depth of device....."
              />
            </div>

            <div>
              <FormLabel>Sim Number</FormLabel>
              <FormControl
                type="number"
                value={simNumber}
                onChange={(e) => setSimNumber(e.target.value)}
                placeholder="Enter SIM number....."
              />
            </div>

            <div>
              <FormLabel>Latitude</FormLabel>
              <FormControl
                type="number"
                step="any"
                value={latitude}
                onChange={(e) => setLatitude(e.target.value)}
                placeholder="Enter latitude (e.g., 40.7128)"
              />
            </div>

            <div>
              <FormLabel>Longitude</FormLabel>
              <FormControl
                type="number"
                step="any"
                value={longitude}
                onChange={(e) => setLongitude(e.target.value)}
                placeholder="Enter longitude (e.g., -74.0060)"
              />
            </div>

            <div>
              <FormLabel>Location</FormLabel>
              <FormControl
                type="text"
                value={location}
                onChange={(e) => setLocation(e.target.value)}
                placeholder="Enter location description (e.g., New York, NY)"
              />
            </div>

            {/* READ-ONLY: Installation Date */}
            <div>
              <FormLabel>Installation Date</FormLabel>
              <FormControl
                type="date"
                value={installationDate}
                disabled
                readOnly
                style={{ backgroundColor: "#f0f0f0", cursor: "not-allowed" }}
              />
            </div>

            {/* READ-ONLY: Activation Date */}
            <div>
              <FormLabel>Activation Date</FormLabel>
              <FormControl
                type="date"
                value={activationDate}
                disabled
                readOnly
                style={{ backgroundColor: "#f0f0f0", cursor: "not-allowed" }}
              />
            </div>

            {/* READ-ONLY: Subscription End Date */}
            <div>
              <FormLabel>Subscription End Date</FormLabel>
              <FormControl
                type="date"
                value={subscriptionEndDate}
                disabled
                readOnly
                style={{ backgroundColor: "#f0f0f0", cursor: "not-allowed" }}
              />
            </div>

            {/* READ-ONLY: Subscription Cost */}
            <div>
              <FormLabel>Subscription Cost</FormLabel>
              <FormControl
                type="number"
                value={subscriptionCost}
                placeholder="Subscription cost"
                disabled
                readOnly
                style={{ backgroundColor: "#f0f0f0", cursor: "not-allowed" }}
              />
            </div>
          </div>

          <div className="form-btn d-flex align-items-center mt-5">
            <button onClick={handleSubmit} type="submit" className="white-btn">
              Save
            </button>
            <button onClick={handleReset} className="white-btn ms-4">
              Reset
            </button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};

export default EditDeviceDealer;
